// The version of a seat's metric set (KPI-FIX #1): content-derived, shared by the API, its tests
// and the web fake twin. Zod-free on purpose: the web bundle runs under a CSP without
// `unsafe-eval`, and zod probes `new Function` when loaded (`@companyos/schema/seat-metric-set`).
export type SeatMetricSetLine = {
  metric_def_id: string;
  kpi_weight: string | number;
  goal_weight: string | number;
  tracking_mode: string;
  penalty_only: boolean;
  position: number;
};

/**
 * The version of a seat's metric set (04 §Optimistic concurrency, `"{version}"`): FNV-1a over the
 * lines in position order, weights compared as numbers (`"1.000"` is `1`), folded to nine digits.
 * A set that is back to an earlier content has that content's version again, which is harmless:
 * a write under it replaces exactly what its writer saw. The API and the fake twin share it.
 */
export function seatMetricSetVersion(lines: readonly SeatMetricSetLine[]): number {
  const text = [...lines]
    .sort((a, b) => a.position - b.position || a.metric_def_id.localeCompare(b.metric_def_id))
    .map((l) =>
      [
        l.metric_def_id,
        Number(l.kpi_weight),
        Number(l.goal_weight),
        l.tracking_mode,
        l.penalty_only ? 1 : 0,
        l.position,
      ].join("|"),
    )
    .join(";");
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h % 1_000_000_000;
}
